import { render, staticRenderFns } from "./PaymentsOtrosPagos.vue?vue&type=template&id=cb6cdcf0&scoped=true&"
import script from "./PaymentsOtrosPagos.vue?vue&type=script&lang=js&"
export * from "./PaymentsOtrosPagos.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsOtrosPagos.vue?vue&type=style&index=0&id=cb6cdcf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6cdcf0",
  null
  
)

export default component.exports